import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { adminService } from "../services/api";
import "./LandingPage.css";

const LandingPage = () => {
  const [bgImage, setBgImage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBg = async () => {
      try {
        const settings = await adminService.getSettings();
        if (settings) {
          let banners = [];
          if (settings.landing_banners) {
            try {
              banners = JSON.parse(settings.landing_banners);
            } catch (e) {
              banners = [settings.landing_banners];
            }
          } else if (settings.landing_banner) {
            banners = [settings.landing_banner];
          }

          if (banners.length > 0) {
            const randomBanner = banners[Math.floor(Math.random() * banners.length)];
            setBgImage(randomBanner);
          }
        }
      } catch (error) {
        console.error("Error fetching landing banner:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBg();
  }, []);

  return (
    <div className="landing-page" style={{ 
      backgroundImage: bgImage ? `url(${bgImage})` : 'url("https://images.unsplash.com/photo-1560958089-b8a1929cea89?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")' 
    }}>
      <div className="landing-overlay">
        <div className="landing-content">
          <h1 className="landing-title">Cùng VinFast Bứt Phá Mọi Giới Hạn</h1>
          <p className="landing-subtitle">Khám phá các dòng xe ô tô điện thông minh đẳng cấp thế giới</p>
          <Link to="/home" className="btn-enter">
            VÀO XEM XE <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
